<template>
  <el-form ref="form" :inline="true" size="mini">
    <el-form-item>
      <el-tooltip placement="top">
        <div slot="content">Поиск по login, email, ID</div>
        <el-input
          prefix-icon="el-icon-search"
          placeholder="Введите и нажмите Enter"
          v-model="localSearchString"
          @change="performSearch"
          clearable
        >
        </el-input>
      </el-tooltip>
    </el-form-item>
    <el-form-item>
      <el-tooltip placement="top">
        <div slot="content">Фильтр по типу пользователя</div>
        <el-select
          placeholder="Тип пользователя"
          v-model="localType"
          @change="performSearch"
          clearable
          filterable
        >
          <el-option
            v-for="item in typeOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-tooltip>
    </el-form-item>
    <el-form-item>
      <el-tooltip placement="top">
      <div slot="content">Фильтр по партнерской программе</div>
        <el-input
          type="number"
          placeholder="0.003 - 0,03 %"
          title="0.003 - 0,03 %"
          step="0.001"
          v-model="localPartnerPercent"
          @change="performSearch"
          clearable
        >
        </el-input>
      </el-tooltip>
    </el-form-item>
    <el-form-item>
      <el-button
        v-if="isFiltered"
        type="danger"
        size="mini"
        @click="resetSearch"
        >Сбросить фильтры</el-button
      >
    </el-form-item>
  </el-form>
</template>
<script>
import { mapState, mapActions } from "vuex";
export default {
  name: "UsersFilterForm",
  data: () => ({
    typeOptions: [
      { label: 'Пользователь', value: 3 },
      { label: 'Модератор', value: 2 },
      { label: 'Админ', value: 1 }
    ]
  }),
  computed: {
    ...mapState("users", ["searchString", "type", "partnerPercent", "isFiltered"]),
    localSearchString: {
      get() {
        return this.searchString;
      },
      set(val) {
        this.changeSearchString({ searchString: val });
      }
    },
    localType: {
      get() {
        return this.type;
      },
      set(val) {
        this.changeType({ type: val });
      }
    },
    localPartnerPercent: {
      get() {
        return this.partnerPercent;
      },
      set(val) {
        this.changePartnerPercent({ partnerPercent: val });
      }
    }
  },
  methods: {
    ...mapActions("users", [
      "changeSearchString",
      "changeType",
      "changePartnerPercent",
      "performSearch",
      "resetSearch"
    ])
  },
  async mounted() {}
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/components/ui/UsersFiltersForm.vue